import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
})
export class UnauthorizedComponent implements OnInit {
  isAuthenticated: boolean = false;
  errorMessage: string = '';

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.checkAuthenticationStatus();
  }

  checkAuthenticationStatus() {
    // Simple check without auto-redirect
    this.authService.isAuthenticated().subscribe({
      next: (isAuthenticated: boolean) => {
        this.isAuthenticated = isAuthenticated;
        console.log(
          'Authentication Status:',
          isAuthenticated ? 'Passed' : 'Failed'
        );

        if (isAuthenticated) {
          this.saveTokensToStorage();
        }
      },
      error: (error) => {
        console.error('Auth check failed:', error);
        this.isAuthenticated = false;
        this.errorMessage = 'Authentication check failed. Please try again.';
      },
    });
  }

  private saveTokensToStorage() {
    try {
      this.oidcSecurityService.userData$.subscribe((userData) => {
        const accessToken = this.oidcSecurityService.getToken();
        const idToken = this.oidcSecurityService.getIdToken();
        const refreshToken = this.oidcSecurityService.getRefreshToken();

        if (accessToken) {
          sessionStorage.setItem('access_token', accessToken);
          sessionStorage.setItem('id_token', idToken);
          sessionStorage.setItem('refresh_token', refreshToken);
          console.log('Tokens saved to sessionStorage.');
        }
      });
    } catch (error) {
      console.error('Error saving tokens:', error);
    }
  }

  navigateToProductSelection() {
    if (this.isAuthenticated) {
      this.router
        .navigate(['/product-selection'], { replaceUrl: true })
        .catch((error) => {
          this.errorMessage = 'Navigation failed. Please try again.';
          console.error('Navigation error:', error);
        });
    } else {
      this.errorMessage = 'Please authenticate first before proceeding.';
    }
  }

  goToLogin() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  retryCheck() {
    this.errorMessage = '';
    this.checkAuthenticationStatus();
  }

  retryNavigation() {
    this.errorMessage = '';
    this.navigateToProductSelection();
  }
}
